import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { ProductImageSizesPortraitEnum } from '@as-react/common-types';
import { usePinchZoomCarouselGestureHandoff } from '@yonderland/andes-react';
import { useEffect, useRef, useState } from 'react';
import { ProductMediaItem } from '../product-media/ProductMediaItem';
export const ProductMediaCarouselItem = (_a) => {
    var { shouldLoadBackgroundImage } = _a, rest = __rest(_a, ["shouldLoadBackgroundImage"]);
    const [didLoadImage, setDidLoadImage] = useState(!shouldLoadBackgroundImage);
    useEffect(() => {
        if (!shouldLoadBackgroundImage) {
            return;
        }
        setDidLoadImage(false);
        const imageLoader = new Image();
        imageLoader.src = rest.sourceSet[ProductImageSizesPortraitEnum.detail];
        imageLoader.decoding = 'sync';
        imageLoader.onload = () => {
            setDidLoadImage(true);
        };
    }, [rest.sourceSet, shouldLoadBackgroundImage]);
    return didLoadImage ? _jsx(ProductMediaItem, Object.assign({}, rest)) : null;
};
export const PinchAwareProductMediaCarouselItem = (_a) => {
    var { api, isActive } = _a, rest = __rest(_a, ["api", "isActive"]);
    const pinchZoomRef = useRef(null);
    const { slideRef, handlePointerDownCapture, handlePointerUpCapture } = usePinchZoomCarouselGestureHandoff(api, () => { var _a; return (_a = pinchZoomRef.current) === null || _a === void 0 ? void 0 : _a.resetZoom(); });
    return (_jsx("div", { ref: slideRef, style: { width: '100%', display: 'flex', justifyContent: 'center', overflow: 'hidden' }, onPointerDownCapture: handlePointerDownCapture, onPointerUpCapture: handlePointerUpCapture, children: _jsx(ProductMediaCarouselItem, Object.assign({}, rest, { isActive: isActive, pinchZoomRef: pinchZoomRef })) }));
};
